// Who is responsible for personal information on this portal, for the Privacy Policy, Terms of Use and Cookie Policy
// (/privacy, /terms, /cookies; text in ./policies.js). Fill in the agency's contact details and its Data Protection
// Officer before relying on the pages: empty values are left out and the pages point to the agency's offices instead.
// claimify-front serves several agencies: the FHIS portal domain names FHIS, every other domain the shared portal.

const operator = {
  name: "Hayok Medicare", // registered company name and RC number, if they should appear
  email: "support@hayokmedicare.ng",
};

const FHIS = {
  platform: "Claimify",
  operator,
  portal: "the FHIS portal",
  portalTitle: "FHIS Portal",
  agency: {
    name: "FCT Health Insurance Scheme",
    short: "FHIS",
    state: "Federal Capital Territory",
    website: "https://fhis.abj.gov.ng",
    dpoEmail: "", // Data Protection Officer
    email: "",
    phone: "",
    address: "",
  },
  governingLaw: "the laws of the Federal Republic of Nigeria, as they apply in the Federal Capital Territory",
};

const SHARED = {
  platform: "Claimify",
  operator,
  portal: "the Claimify portal",
  portalTitle: "Claimify",
  agency: {
    name: "the health insurance agency or programme that enrolled you or that you work with",
    short: "",
    genericNote: "(for patients of a health facility that uses the portal independently, that facility)",
    state: "",
    website: "",
    dpoEmail: "",
    email: "",
    phone: "",
    address: "",
  },
  governingLaw: "the laws of the Federal Republic of Nigeria and of the State whose agency runs your programme",
};

const host = typeof window !== "undefined" ? window.location.hostname : "";
export default /(^|\.)fhis\.abj\.gov\.ng$/.test(host) ? FHIS : SHARED;
